module.exports = __webpack_public_path__ + "img/13.44cc8e77.jpeg";